import { useMutation, useQuery, UseMutationOptions, UseQueryOptions } from '@tanstack/react-query'
import { TUseMutationOptions, TUseQueryOptions, TCustomUseQueryMeta } from 'core/query/type'
import {
  TGetWeb3WalletChainPageParams,
  TGetWeb3WalletChainPageResponse,
  getWeb3WalletChainPage,
  TGetWeb3WalletGetConfigParams,
  TGetWeb3WalletGetConfigResponse,
  getWeb3WalletGetConfig,
  TPostWeb3WalletSavaLoginLogParams,
  TPostWeb3WalletSavaLoginLogResponse,
  postWeb3WalletSavaLoginLog,
  TPostWeb3WalletSavaUserWalletParams,
  TPostWeb3WalletSavaUserWalletResponse,
  postWeb3WalletSavaUserWallet,
  TGetWeb3WalletTokenPageParams,
  TGetWeb3WalletTokenPageResponse,
  getWeb3WalletTokenPage,
  TGetWeb3WalletConfirmQrcodeParams,
  TGetWeb3WalletConfirmQrcodeResponse,
  getWeb3WalletConfirmQrcode,
  TPostWeb3WalletDetermineParams,
  TPostWeb3WalletDetermineResponse,
  postWeb3WalletDetermine,
  TGetWeb3WalletGenerateQrcodeParams,
  TGetWeb3WalletGenerateQrcodeResponse,
  getWeb3WalletGenerateQrcode,
  TGetWeb3WalletScanLoginParams,
  TGetWeb3WalletScanLoginResponse,
  getWeb3WalletScanLogin,
  TGetWeb3WalletChainAllParams,
  TGetWeb3WalletChainAllResponse,
  getWeb3WalletChainAll,
  TGetWeb3WalletTokenAllParams,
  TGetWeb3WalletTokenAllResponse,
  getWeb3WalletTokenAll,
  TGetWeb3WalletAccountDataListParams,
  TGetWeb3WalletAccountDataListResponse,
  getWeb3WalletAccountDataList,
  TPostWeb3WalletChangeStatusChainParams,
  TPostWeb3WalletChangeStatusChainResponse,
  postWeb3WalletChangeStatusChain,
  TPostWeb3WalletChangeStatusTokenParams,
  TPostWeb3WalletChangeStatusTokenResponse,
  postWeb3WalletChangeStatusToken,
  TPostWeb3WalletRemoveChainParams,
  TPostWeb3WalletRemoveChainResponse,
  postWeb3WalletRemoveChain,
  TPostWeb3WalletRemoveTokenParams,
  TPostWeb3WalletRemoveTokenResponse,
  postWeb3WalletRemoveToken,
  TPostWeb3WalletSavaChainParams,
  TPostWeb3WalletSavaChainResponse,
  postWeb3WalletSavaChain,
  TPostWeb3WalletSavaTokenParams,
  TPostWeb3WalletSavaTokenResponse,
  postWeb3WalletSavaToken,
  TPostWeb3WalletUpdateConfigParams,
  TPostWeb3WalletUpdateConfigResponse,
  postWeb3WalletUpdateConfig,
  TGetWeb3WalletUserDataPageParams,
  TGetWeb3WalletUserDataPageResponse,
  getWeb3WalletUserDataPage,
  TGetWeb3WalletDexTokenPageParams,
  TGetWeb3WalletDexTokenPageResponse,
  getWeb3WalletDexTokenPage,
} from 'core/service/yapi/hk-web/Web3Wallet/api'
// Web3钱包相关接口
// 分页查询主网
export const useGetWeb3WalletChainPageQuery = (
  params?: TGetWeb3WalletChainPageParams,
  options?: TUseQueryOptions<TGetWeb3WalletChainPageResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Web3Wallet', 'Web3WalletChainPage', 'GET', ...Object.values(params || {})],
    queryFn: () => getWeb3WalletChainPage(params, options?.meta?.requestOptions),
  })
}

// 获取配置
export const useGetWeb3WalletGetConfigQuery = (
  params?: TGetWeb3WalletGetConfigParams,
  options?: TUseQueryOptions<TGetWeb3WalletGetConfigResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Web3Wallet', 'Web3WalletGetConfig', 'GET', ...Object.values(params || {})],
    queryFn: () => getWeb3WalletGetConfig(params, options?.meta?.requestOptions),
  })
}

// 保存用户登陆日志
export const usePostWeb3WalletSavaLoginLogMutation = (
  mutationOptions?: TUseMutationOptions<TPostWeb3WalletSavaLoginLogResponse, TPostWeb3WalletSavaLoginLogParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Web3Wallet', 'Web3WalletSavaLoginLog', 'Post'],
    mutationFn: (params?: TPostWeb3WalletSavaLoginLogParams) =>
      postWeb3WalletSavaLoginLog(params, mutationOptions?.meta?.requestOptions),
  })
}

// 保存用户钱包
export const usePostWeb3WalletSavaUserWalletMutation = (
  mutationOptions?: TUseMutationOptions<TPostWeb3WalletSavaUserWalletResponse, TPostWeb3WalletSavaUserWalletParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Web3Wallet', 'Web3WalletSavaUserWallet', 'Post'],
    mutationFn: (params?: TPostWeb3WalletSavaUserWalletParams) =>
      postWeb3WalletSavaUserWallet(params, mutationOptions?.meta?.requestOptions),
  })
}

// 分页查询币种
export const useGetWeb3WalletTokenPageQuery = (
  params?: TGetWeb3WalletTokenPageParams,
  options?: TUseQueryOptions<TGetWeb3WalletTokenPageResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Web3Wallet', 'Web3WalletTokenPage', 'GET', ...Object.values(params || {})],
    queryFn: () => getWeb3WalletTokenPage(params, options?.meta?.requestOptions),
  })
}

// app扫码确认信息
export const useGetWeb3WalletConfirmQrcodeQuery = (
  params?: TGetWeb3WalletConfirmQrcodeParams,
  options?: TUseQueryOptions<TGetWeb3WalletConfirmQrcodeResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Web3Wallet', 'Web3WalletConfirmQrcode', 'GET', ...Object.values(params || {})],
    queryFn: () => getWeb3WalletConfirmQrcode(params, options?.meta?.requestOptions),
  })
}

// app扫码后将qrCodeToken与钱包绑定
export const usePostWeb3WalletDetermineMutation = (
  mutationOptions?: TUseMutationOptions<TPostWeb3WalletDetermineResponse, TPostWeb3WalletDetermineParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Web3Wallet', 'Web3WalletDetermine', 'Post'],
    mutationFn: (params?: TPostWeb3WalletDetermineParams) =>
      postWeb3WalletDetermine(params, mutationOptions?.meta?.requestOptions),
  })
}

// 生成扫码登录二维码token,前端获取到该token之后生成二维码图片
export const useGetWeb3WalletGenerateQrcodeQuery = (
  params?: TGetWeb3WalletGenerateQrcodeParams,
  options?: TUseQueryOptions<TGetWeb3WalletGenerateQrcodeResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Web3Wallet', 'Web3WalletGenerateQrcode', 'GET', ...Object.values(params || {})],
    queryFn: () => getWeb3WalletGenerateQrcode(params, options?.meta?.requestOptions),
  })
}

// ajax定时请求是否有用户扫描了二维码
export const useGetWeb3WalletScanLoginQuery = (
  params?: TGetWeb3WalletScanLoginParams,
  options?: TUseQueryOptions<TGetWeb3WalletScanLoginResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Web3Wallet', 'Web3WalletScanLogin', 'GET', ...Object.values(params || {})],
    queryFn: () => getWeb3WalletScanLogin(params, options?.meta?.requestOptions),
  })
}

// 查询所有主网
export const useGetWeb3WalletChainAllQuery = (
  params?: TGetWeb3WalletChainAllParams,
  options?: TUseQueryOptions<TGetWeb3WalletChainAllResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Web3Wallet', 'Web3WalletChainAll', 'GET', ...Object.values(params || {})],
    queryFn: () => getWeb3WalletChainAll(params, options?.meta?.requestOptions),
  })
}

// 查询所有币种
export const useGetWeb3WalletTokenAllQuery = (
  params?: TGetWeb3WalletTokenAllParams,
  options?: TUseQueryOptions<TGetWeb3WalletTokenAllResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Web3Wallet', 'Web3WalletTokenAll', 'GET', ...Object.values(params || {})],
    queryFn: () => getWeb3WalletTokenAll(params, options?.meta?.requestOptions),
  })
}

// 查询钱包ID下面的账户数据
export const useGetWeb3WalletAccountDataListQuery = (
  params?: TGetWeb3WalletAccountDataListParams,
  options?: TUseQueryOptions<TGetWeb3WalletAccountDataListResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Web3Wallet', 'Web3WalletAccountDataList', 'GET', ...Object.values(params || {})],
    queryFn: () => getWeb3WalletAccountDataList(params, options?.meta?.requestOptions),
  })
}

// 改变状态主网
export const usePostWeb3WalletChangeStatusChainMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostWeb3WalletChangeStatusChainResponse,
    TPostWeb3WalletChangeStatusChainParams
  > & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Web3Wallet', 'Web3WalletChangeStatusChain', 'Post'],
    mutationFn: (params?: TPostWeb3WalletChangeStatusChainParams) =>
      postWeb3WalletChangeStatusChain(params, mutationOptions?.meta?.requestOptions),
  })
}

// 改变状态币种
export const usePostWeb3WalletChangeStatusTokenMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostWeb3WalletChangeStatusTokenResponse,
    TPostWeb3WalletChangeStatusTokenParams
  > & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Web3Wallet', 'Web3WalletChangeStatusToken', 'Post'],
    mutationFn: (params?: TPostWeb3WalletChangeStatusTokenParams) =>
      postWeb3WalletChangeStatusToken(params, mutationOptions?.meta?.requestOptions),
  })
}

// 逻辑删除主网
export const usePostWeb3WalletRemoveChainMutation = (
  mutationOptions?: TUseMutationOptions<TPostWeb3WalletRemoveChainResponse, TPostWeb3WalletRemoveChainParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Web3Wallet', 'Web3WalletRemoveChain', 'Post'],
    mutationFn: (params?: TPostWeb3WalletRemoveChainParams) =>
      postWeb3WalletRemoveChain(params, mutationOptions?.meta?.requestOptions),
  })
}

// 逻辑删除数据币种
export const usePostWeb3WalletRemoveTokenMutation = (
  mutationOptions?: TUseMutationOptions<TPostWeb3WalletRemoveTokenResponse, TPostWeb3WalletRemoveTokenParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Web3Wallet', 'Web3WalletRemoveToken', 'Post'],
    mutationFn: (params?: TPostWeb3WalletRemoveTokenParams) =>
      postWeb3WalletRemoveToken(params, mutationOptions?.meta?.requestOptions),
  })
}

// 保存或更新主网
export const usePostWeb3WalletSavaChainMutation = (
  mutationOptions?: TUseMutationOptions<TPostWeb3WalletSavaChainResponse, TPostWeb3WalletSavaChainParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Web3Wallet', 'Web3WalletSavaChain', 'Post'],
    mutationFn: (params?: TPostWeb3WalletSavaChainParams) =>
      postWeb3WalletSavaChain(params, mutationOptions?.meta?.requestOptions),
  })
}

// 保存或更新币种
export const usePostWeb3WalletSavaTokenMutation = (
  mutationOptions?: TUseMutationOptions<TPostWeb3WalletSavaTokenResponse, TPostWeb3WalletSavaTokenParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Web3Wallet', 'Web3WalletSavaToken', 'Post'],
    mutationFn: (params?: TPostWeb3WalletSavaTokenParams) =>
      postWeb3WalletSavaToken(params, mutationOptions?.meta?.requestOptions),
  })
}

// 更新配置
export const usePostWeb3WalletUpdateConfigMutation = (
  mutationOptions?: TUseMutationOptions<TPostWeb3WalletUpdateConfigResponse, TPostWeb3WalletUpdateConfigParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['Web3Wallet', 'Web3WalletUpdateConfig', 'Post'],
    mutationFn: (params?: TPostWeb3WalletUpdateConfigParams) =>
      postWeb3WalletUpdateConfig(params, mutationOptions?.meta?.requestOptions),
  })
}

// 分页查询用户数据
export const useGetWeb3WalletUserDataPageQuery = (
  params?: TGetWeb3WalletUserDataPageParams,
  options?: TUseQueryOptions<TGetWeb3WalletUserDataPageResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Web3Wallet', 'Web3WalletUserDataPage', 'GET', ...Object.values(params || {})],
    queryFn: () => getWeb3WalletUserDataPage(params, options?.meta?.requestOptions),
  })
}

// 分页查询dex币种
export const useGetWeb3WalletDexTokenPageQuery = (
  params?: TGetWeb3WalletDexTokenPageParams,
  options?: TUseQueryOptions<TGetWeb3WalletDexTokenPageResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['Web3Wallet', 'Web3WalletDexTokenPage', 'GET', ...Object.values(params || {})],
    queryFn: () => getWeb3WalletDexTokenPage(params, options?.meta?.requestOptions),
  })
}
